import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import initBootstrapComponents from '../../utils/bootstrap';
import '@splidejs/react-splide/css';
import 'bootstrap/dist/css/bootstrap.min.css';
import Header from '../../components/Header/Header';
import Footer from '../../components/Footer/Footer';
import { useBasket } from '../../context/BasketContext';

// Import images
import alfaRomeoTonale from '../../assets/img/content/alfa-romeo-tonale.png';
import kiaNiro from '../../assets/img/content/kia-niro.png';

const BookingConfirmation = () => {
    const { basket } = useBasket();

    useEffect(() => {
        initBootstrapComponents();
    }, []);

    // Format date to match the design
    const formatDate = (date) => {
        return new Date(date).toLocaleDateString('en-GB', {
            weekday: 'long',
            day: 'numeric',
            month: 'long',
            year: 'numeric'
        });
    };

    // Format time to match the design
    const formatTime = (dateTimeString) => {
        return new Date(dateTimeString).toLocaleTimeString('en-GB', {
            hour: 'numeric',
            minute: '2-digit',
            hour12: true
        }).toLowerCase();
    };

    const customerDetails = JSON.parse(localStorage.getItem('customerDetails'));
    const bookingConfirmation = JSON.parse(localStorage.getItem('bookingConfirmation'));

    const groupedBookings = bookingConfirmation?.bookings?.reduce((acc, booking) => {
        const date = formatDate(booking.start_at);
        if (!acc[date]) {
            acc[date] = [];
        }
        acc[date].push(booking);
        return acc;
    }, {});

    const getVehicleFromSlot = (booking,vehicleId) => {
        // const slot = booking.slots.find(slot => slot.id === slotId);
        const vehicle = booking.slot.vehicles.find(vehicle => vehicle.id === vehicleId);
        return vehicle;
    }

    const printBookingConfirmation = (booking) => {
        window.open(booking.ambassador_print_url, '_blank');
    }

    return (
        <div className="d-flex flex-column justify-content-between min-vh-100" id="body-container">
            <Header />

            <main>
                <section className="bg-motability-mid-black-5 py-32 pt-lg-96 pb-lg-411" id="book-a-test-drive-booking-confirmation">
                    <div className="container">
                        <h1 className="text-primary mb-4 mb-lg-5">
                            Booking confirmation
                        </h1>

                        <div className="bg-motability-white border border-motability-light-blue rounded-4 p-4 p-lg-32">
                            {/* <h6 className="text-primary text-uppercase fw-medium mb-3">
                                {basket.event_name && basket.event_name}
                            </h6> */}

                            <div className="row row-gap-4 row-gap-lg-0 gx-xxl-5">
                                <div className="col-lg-6">
                                    <div className="bg-motability-mid-black-5 border border-motability-mid-black-2 rounded-4 p-4 p-lg-32">
                                        <h5 className="text-primary mb-3">
                                            Your booking
                                        </h5>
                                        
                                        <div className="order-items">
                                            {groupedBookings && Object.entries(groupedBookings).map(([date, bookings]) => (
                                                bookings.map((booking) => {
                                                    const vehicle = getVehicleFromSlot(booking, booking.vehicle_id);
                                                    return (
                                                        <div key={booking.id} className="order-item py-3 d-flex align-items-center gap-3">
                                                            {vehicle?.images_array?.[0] && (
                                                                <div className="vehicle-image-container" style={{ width: '120px', flexShrink: 0 }}>
                                                                    <img 
                                                                        src={vehicle.images_array[0]} 
                                                                        alt={vehicle.name}
                                                                        className="img-fluid rounded-3"
                                                                        style={{ width: '100%', height: 'auto' }}
                                                                    />
                                                                </div>
                                                            )}
                                                            <div className="d-flex flex-column flex-1 gap-2">
                                                                <div className="d-flex flex-column">
                                                                    <p className="fw-semibold mb-0">
                                                                        {/* {booking.event_name} */}
                                                                    </p>
                                                                    <p className="fw-semibold mb-0">
                                                                        {vehicle?.name}
                                                                    </p>
                                                                    <p className="fw-semibold mb-2">
                                                                        {date}
                                                                    </p>
                                                                    <p className="mb-0" id="booked-from-date">
                                                                        <span className="fw-semibold">Time:</span> {formatTime(booking.start_at)}
                                                                    </p>
                                                                </div>
                                                                <button 
                                                                    className="btn btn-outline-primary btn-sm mt-2 align-self-start" 
                                                                    onClick={() => printBookingConfirmation(booking)}
                                                                >
                                                                    Print Confirmation
                                                                </button>
                                                            </div>
                                                       
                                                        </div>
                                                    );
                                                })
                                            ))}
                                        </div>

                                        <h6 className="text-primary mb-3 mt-4">
                                            Guest details
                                        </h6>
                                        <p className="fw-semibold mb-2">
                                            <span className="text-motability-black">Name:</span> {customerDetails?.firstName} {customerDetails?.lastName}
                                        </p>

                                        <p className="mb-2">
                                            <span className="text-motability-black">Phone:</span> {customerDetails?.telephone}
                                        </p>

                                        <p className="mb-0">
                                            <span className="text-motability-black">Email:</span> {customerDetails?.email}
                                        </p>

                                        {customerDetails?.houseNumber && (
                                            <p className="mb-0">
                                                <span className="text-motability-black">House/Flat Number:</span> {customerDetails.houseNumber}
                                            </p>
                                        )}

                                        {customerDetails?.postcode && (
                                            <p className="mb-0">
                                                <span className="text-motability-black">Postcode:</span> {customerDetails.postcode}
                                            </p>
                                        )}
                                    </div>
                                </div>

                                <div className="col-lg-6">
                                    <div className="content">
                                        <h5 className="text-motability-black mb-3">
                                            What do I do next?
                                        </h5>

                                        <p>
                                            Please arrive at least 10 minutes before your scheduled test drive time. 
                                            Bring your driving license and any necessary documentation. 
                                            Our team will be ready to assist you with your test drive experience.
                                        </p>
                                    </div>

                                    <div className="content mt-4">
                                        <h5 className="text-motability-black mb-3">
                                            What if I can no longer attend?
                                        </h5>

                                        <p>
                                            If you need to cancel or reschedule your test drive, please contact us as soon as possible. 
                                            You can reach us at the contact details provided above. We'll do our best to accommodate your needs.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </main>

            <Footer />
        </div>
    );
};

export default BookingConfirmation;
